window.$ = window.jQuery = require("jquery");
require("./web_function");

// import Swiper, { Navigation,Pagination,EffectFade,Autoplay, EffectCreative } from 'swiper';
// import 'swiper/css/effect-fade';
// import 'swiper/module/effect-creative';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Draggable } from "gsap/Draggable";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(Draggable);

// window.Swiper         = Swiper;
// window.Navigation     = Navigation;
// window.Pagination     = Pagination;
// window.Autoplay       = Autoplay;
// window.EffectFade     = EffectFade;
// window.EffectCreative = EffectCreative;

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
window.Draggable = Draggable;

$(function () {
    $(".rd_goto_url").on("click", function () {
        gotoURL($(this).data("url"));
    });
});
